import React, {
  useState,
  useMemo,
  useEffect,
  useRef,
  useContext,
  useCallback,
} from "react";
import filter from "../../../images/Icons/tune.svg";
import arrowLeft from "../../../images/Icons/arrow_left.svg";
import Fullscreen from "../../../images/Icons/full-screen.svg";
import gcda_logo from "../../../images/GCDA White logo.svg";
import { setIs1kViewEnabled } from "../../../utils/httpClient";

import searchIcon from "../../../images/search-icon.png";

import {
  colors4,
  colors9,
  colors7,
  tmbmsipdlcolors,
} from "../../../utils/constants";
import Highcharts from "highcharts";
import VariablePie from "highcharts/modules/variable-pie";
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate, useLocation } from "react-router-dom";
import { AuthContext } from "../../../Context/context";
import "./styles.css";
import CancerSites from "./CancerSitesSection/index.jsx";
import MorphologySomaticGermlineLazyLoadWrapper from "./Morphology_Somatic_Germline_Section/MorphologySomaticGermlineLazyLoadWrapper.jsx";
import BiomarkersLazyLoadWrapper from "./BiomarkersSection/BiomarkersLazyLoadWrapper.jsx";
import TmbMsiPdlLazyLoadWrapper from "./TMB_MSI_PDL_Section/TmbMsiPdlLazyLoadWrapper.jsx";
import TreatmentDetailsLazyLoadWrapper from "./TreatmentDetails_Section/TreatmentDetailsLazyLoadWrapper.jsx";
import DrugTherapyLazyLoadWrapper from "./DrugTherapy_Section/DrugTherapyLazyLoadWrapper.jsx";
import GenderAgeDistrubtutionLazyLoadWrapper from "./GenderAge_Section/GenderAgeDistrubtutionLazyLoadWrapper.jsx";
import HospitalTestTypeLazyLoadWrapper from "./TestTypes_Hospital_City_Section/HospitalTestTypeLazyLoadWrapper.jsx";
import Footer from "../../../Components/Footer";
import {
  SourceContext,
  UserDatailContext,
} from "../../../Context/userContext.js";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";
import Icon from "./Icon";
import VarinatAndProteinDistrubutionLazyLoadWrapper from "./Varinat_Protein_Distrubution_Section/VarinatAndProteinDistrubutionLazyLoadWrapper.jsx";
import debounce from "lodash.debounce";
import { LocalStorageKeys, LocalStorageService } from "../../../utils/LocalStorageService.js";
import Roles from "../../../utils/roles";


Highcharts.Templating = { helpers: {} };
Highcharts.Templating.helpers.abs = (value) => Math.abs(value);
if (typeof variablePie === "function") {
  VariablePie(Highcharts);
}

function Dashboard(props) {

  const formatBiomarkerName = (name) => {
    if (!name) return name;
    const processedName = name.trim().toLowerCase();
    if (
      processedName === "no clinically relevant mutations detected"
    ) {
      return "NCRMD";
    }
    return name;
  };
  const {
    cancerSiteTop10Data,
    top10totalCount,
    cancerSiteRestOfData,
    totalCount,
    cansiteName,
    geneCancer,
    tmbData,
    tmbTotal,
    msiData,
    msiTotal,
    totalValue,
    primarySite,
    pdlData,
    pdlTotal,
    treatmentDetails,
    treatmentsTotal,
    biologicalTherapy,
    biologicalTotal,
    drugTherapy,
    drugTotal,
    drugsCountTotal,
    drugsCount,
    recistCriteria,
    recistCriteriaTotal,
    somaticGermline,
    variantTypeResponse,
    somaticTotal,
    variantTypeTotal,
    fromDate,
    toDate,
    setFromDate,
    setToDate,
    setSelectedGenes,
    setImmunoFilter,
    setTargetedFilter,
    genderAgeGroup,
    IsLoading,
    selectedGenes,
    immunoFilter,
    targetedFilter,
    hospitalCityTotal,
    hospitalCityData,
    morphologyData,
    proteinChangeDetails,
    SomaticGermlineAPICall,
    BiomarkersAPICall,
    TmbMsiPdlAPICall,
    TreatmentDetailsAPICall,
    DrugTherapyAPICall,
    GenderAgeDistrubtutionAPICall,
    HospitalAPICall,
    morphologyDataAPICall,
    CancerSitesLoader,
    MorphologySomaticGermlineLoader,
    BiomarkersLoader,
    TmbMsiPdlLoader,
    TreatmentDetailsLoader,
    DrugTherapyLoader,
    GenderAgeDistrubtutionLoader,
    HospitalTestTypeLoader,
    geneCancerAllDataList,
    hospitalNameData,
    immunoFilterData,
    targetedFilterData,
    citiesFilter,
    setCitiesFilter,
    citiesFilterData,
    hospitalsFilter,
    setHospitalsFilter,
    hospitalsFilterData,
    cancerFilterVal1,
    cancerDropdown,
    setCancerFilterVal1,
    targetedTherapy,
    targetedTherapyTotal,
    morphTotalCount,
    isPdlChecked,
    setIsPdlChecked,
    ngsValue,
    setNgsValue,
    cancerStage,
    cancerStageTotal,
    wasManuallyCleared,
    setWasManuallyCleared,
    morphologyFilterVal,
    setMorphologyFilterVal,
    morphologyDropdown,
    doctorsDropdownDataFilter,
    setDoctorsDropdownDataFilter,
    doctorsDropdownData,
    testTypeGraphLoader,
    testTypeTotalCount,
    testTypeGraphData,
    geneDetectionStatus,
    setGeneDetectionStatus,
    testTypeFilter,
    setTestTypeFilter,
    testTypeFilterData,
    minDate,
    maxDate,
    dateRangeLoading,
    hasApiData,
    clinicalSignificanceDropdown,
    setClinicalSignificanceDropdown,
    clinicalSignificanceFilter,
    setClinicalSignificanceFilter,
    clinicalSignificanceTotal,
    hasLungCancerSite,
    userDetails
  } = props;

  const navigate = useNavigate();
  const location = useLocation();
  const {
    lungClicked,
    setLungClicked, is1kViewEnabled,setIs1kViewEnabled: setIs1kViewEnabledContext,
    genderDropdown,genderFilter, setGenderFilter
  } = useContext(SourceContext);
  const { signOutFun } = React.useContext(AuthContext);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [searchTermForCancer, setSearchTermForCancer] = useState("");
  const [searchTermForGene, setSearchTermForGene] = useState("");
  const [searchTermForImmuno, setSearchTermForImmuno] = useState("");
  const [seacrhTermForTargeted, setSeacrhTermForTargeted] = useState("");
  const [searchTermForCities, setSeacrhTermForCities] = useState("");
  const [searchTermForHospitals, setsearchTermForHospitals] = useState("");
  const [searchTermForTestType, setsearchTermForTestType] = useState("");
  const [searchTermForMorphology, setSearchTermForMorphology] = useState("");
  const [searchTermForDoctor, setSearchTermForDoctor] = useState('');
  const [openGroups, setOpenGroups] = useState({});
  const [debouncedSearchTerm, setDebouncedSearchTerm] = useState(searchTermForCancer);
  const [dateError, setDateError] = useState('');
  const [searchTermForClinical, setSearchTermForClinical] = useState("");

  const ngsOptions = ["NGS", "Non-NGS"];
  const geneDetectionStatusOptions = useMemo(() =>
    ["Detected", "Undetected"],
    []);
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [filteredTestTypes, setFilteredTestTypes] = useState([]);
  const [fromDraft, setFromDraft] = useState(null);
  const [toDraft, setToDraft] = useState(null);
  const [selectedQuickRange, setSelectedQuickRange] = useState("");
  const [fromError, setFromError] = useState("");
  const [toError, setToError] = useState("");
  const [isClinicalOpen, setIsClinicalOpen] = useState(false);

  const parseUserDate = useCallback((value) => {
    if (!value) return null;
    const normalized = typeof value === "string" ? value.replace(/-/g, "/") : value;
    if (typeof normalized === "string" && !/^\d{1,2}[/-]\d{1,2}[/-]\d{4}$/.test(normalized)) {
      return null;
    }
    let parsed = dayjs(normalized, "D/M/YYYY", true);
    if (!parsed.isValid()) {
      parsed = dayjs(normalized, "DD/MM/YYYY", true);
    }
    if (!parsed.isValid()) return null;
    const year = parsed.year();
    if (year < 1900 || year > 2099) return null;
    return parsed;
  }, []);

  const handleFromChange = useCallback((value) => {
    if (selectedQuickRange) setSelectedQuickRange("");
    setFromDraft(value);
    if (!value) {
      setFromError("");
      return;
    }
    const parsed = parseUserDate(value);
    if (!parsed) {
      setFromError("Invalid date format (DD/MM/YYYY)");
      return;
    }
    if (parsed.isAfter(dayjs(), "day")) {
      setFromError("Future dates are not allowed");
      return;
    }
    if (toDate && parsed.isAfter(toDate, "day")) {
      setFromError("From Date cannot be after To Date");
      return;
    }
    setFromError("");
  }, [selectedQuickRange, toDate]);

  const handleToChange = useCallback((value) => {
    if (selectedQuickRange) setSelectedQuickRange("");
    setToDraft(value);
    if (!value) {
      setToError("");
      return;
    }
    const parsed = parseUserDate(value);
    if (!parsed) {
      setToError("Invalid date format (DD/MM/YYYY)");
      return;
    }
    if (parsed.isAfter(dayjs(), "day")) {
      setToError("Future dates are not allowed");
      return;
    }
    if (fromDate && parsed.isBefore(fromDate, "day")) {
      setToError("To Date cannot be before From Date");
      return;
    }
    setToError("");
  }, [fromDate, selectedQuickRange]);

  const handleToAccept = useCallback((value) => {
    if (selectedQuickRange) setSelectedQuickRange("");
    const parsed = parseUserDate(value);
    if (!parsed) return;
    if (parsed.isAfter(dayjs(), "day")) return;
    if (fromDate && parsed.isBefore(fromDate, "day")) return;
    setToDate(parsed);
  }, [fromDate, selectedQuickRange]);


  const handleFromAccept = useCallback((value) => {
    if (selectedQuickRange) setSelectedQuickRange("");
    const parsed = parseUserDate(value);
    if (!parsed) return;
    if (parsed.isAfter(dayjs(), "day")) return;
    if (toDate && parsed.isAfter(toDate, "day")) return;
    setFromDate(parsed);
  }, [selectedQuickRange, toDate]);

  const handlerClearr = useCallback(() => {
    setFromDate(null);
    setToDate(null);
    setFromDraft(null);
    setToDraft(null);
    setSelectedQuickRange("");
    setFromError("");
    setToError("");
  }, []);

  const handleQuickDateSelect = useCallback((option) => {
    const referenceDate = maxDate ? dayjs(maxDate) : dayjs();
    let from;
    switch (option) {
      case '1M': from = referenceDate.subtract(1, 'month'); break;
      case '3M': from = referenceDate.subtract(3, 'month'); break;
      case '6M': from = referenceDate.subtract(6, 'month'); break;
      case '1Y': from = referenceDate.subtract(1, 'year'); break;
      default: return;
    }

    // Ensure it doesn't go below minDate
    if (minDate && from.isBefore(dayjs(minDate))) {
      from = dayjs(minDate);
    }

    setFromDate(from);
    setFromDraft(from);
    setToDate(referenceDate);
    setToDraft(referenceDate);
    setSelectedQuickRange(option);
    setFromError("");
    setToError("");
  }, [maxDate, minDate, setFromDate, setToDate]);

  const activeQuickRange = selectedQuickRange;

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchTerm(searchTermForCancer);
    }, 300);

    return () => clearTimeout(handler);
  }, [searchTermForCancer]);

  useEffect(() => {
    setFilteredDoctors(doctorsDropdownData || []);
  }, [doctorsDropdownData]);

  useEffect(() => {
    setFilteredTestTypes(testTypeFilterData || []);
  }, [testTypeFilterData]);

  
  useEffect(() => { }, [isSidebarOpen]);

  useEffect(() => {
    if (location.pathname === "/demo1k" && !is1kViewEnabled) {
      setIs1kViewEnabledContext(true);
      setIs1kViewEnabled(true);
    } else if (location.pathname === "/Dashboard" && is1kViewEnabled) {
      setIs1kViewEnabledContext(true);
      setIs1kViewEnabled(false);
    }

  }, [location.pathname]);

  useEffect(() => {
    const path = location.pathname;
    if (userDetails === undefined || userDetails === null) {
      return;
    }
    const role = userDetails?.role;


    const restrictedForGuest =
      role === Roles.GUEST_ANALYST &&
      (path === "/Dashboard" || path === "/Lung");

    const restrictedForDoctor =
      role === Roles.DOCTOR_ANALYST &&
      !hasLungCancerSite &&
      (path === "/Lung" || path === "/demo1k");

    if (restrictedForGuest || restrictedForDoctor) {
      logout();
    }
  }, [location.pathname, userDetails, hasLungCancerSite]);


  useEffect(() => {
    if (location.pathname === "/Lung" && !lungClicked) {
      setLungClicked(true);
    } else if (location.pathname === "/Dashboard" && lungClicked) {
      setLungClicked(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);


useEffect(() => {
    if(location.pathname === '/Lung')
    setCancerFilterVal1(['Lung']);
  }, [location.pathname, setCancerFilterVal1]);


  const handleNgsSelect = (value) => {
    let formattedValue;

    switch (value) {
      case "Non-NGS":
        formattedValue = "NON_NGS";
        break;
      case "Both":
        formattedValue = "BOTH";
        break;
      default:
        formattedValue = value;
    }

    if (ngsValue !== formattedValue) {
      setNgsValue(formattedValue);
    }
  };

  const series = useMemo(() => {
    if (!cansiteName || !geneCancer) return [];
    return cansiteName.map((site) => ({
      name: site.dataKey,
      color: site.fill,
      data: geneCancer.map((biomarker) => {
        const foundSite = biomarker.sortedSites?.find(
          (s) => s.cancerSiteName === site.dataKey
        );
        return {
          name: biomarker.biomarkerName,
          y: foundSite ? foundSite.cancerSiteCount : null,
          biomarker,
        };
      }),
    }));
  }, [cansiteName, geneCancer]);

  const options = useMemo(
    () => ({
      accessibility: {
        enabled: false,
      },
      chart: {
        type: "column",
        height: 420,
        events: {
          load: function () {
            const chart = this;
            const xAxis = this.xAxis[0];
            if (!xAxis.labelGroup) return;
            const xAxisLabels = xAxis.labelGroup.element.children;

            Array.from(xAxisLabels).forEach((labelEl, index) => {
              labelEl.style.cursor = "pointer";

              labelEl.addEventListener("mouseenter", () => {
                labelEl.style.transition = "all 0.2s ease";
                labelEl.style.fontSize = "12px";
                labelEl.style.fill = "#2E1D51";
                labelEl.style.fontWeight = "bold";

                chart.series.forEach((series) => {
                  const point = series.points[index];
                  if (point && point.graphic) {
                    point.graphic.element.style.transform = "scaleY(1.05)";
                    point.graphic.element.style.transition =
                      "transform 0.2s ease";
                  }
                });
              });

              labelEl.addEventListener("mouseleave", () => {
                labelEl.style.fontSize = "10px";
                labelEl.style.fill = "#000000";
                labelEl.style.fontWeight = "bold";

                chart.series.forEach((series) => {
                  const point = series.points[index];
                  if (point && point.graphic) {
                    point.update(
                      { color: point.options.originalColor || series.color },
                      false,
                      false
                    );
                    point.graphic.element.style.transform = "scaleY(1)";
                  }
                });
              });
            });
          },
        },
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "",
        align: "left",
      },
      xAxis: {
        categories: geneCancer?.map((entry) => entry.biomarkerName),
        labels: {
          y: 10,
          rotation: -45,
          style: {
            fontSize: "10px",
            fontWeight: "bold",
          },
          step: 1,
        },
      },
      yAxis: {
        min: 0,
        title: {
          text: "",
        },
        stackLabels: {
          enabled: true,
        },
      },
      legend: {
        enabled: false,
      },
      tooltip: {
        shared: true,
        useHTML: true,
        formatter: function () {
          const biomarker = this.points?.[0]?.point?.biomarker;
          if (!biomarker || !biomarker.sortedSites) return null;

          const total = biomarker.totalCancerSiteCount;

          const siteValues = biomarker.sortedSites
            .map((site) => {
              const color =
                this.points.find((p) => p.series.name === site.cancerSiteName)
                  ?.series?.color || "#888";
              return `
        <div style="margin: 4px 8px; white-space: nowrap;">
          <span style="color:${color}; font-weight: bold;">${site.cancerSiteName}</span>: ${site.cancerSiteCount}
        </div>`;
            })
            .join("");

          return `
      <div style="padding: 8px; width: 1100px;">
        <div><b>${biomarker.biomarkerName}</b>: ${total}</div>
        <div style="display: flex; flex-wrap: wrap; margin-top: 6px;">
          ${siteValues}
        </div>
      </div>`;
        },
      },
      plotOptions: {
        column: {
          stacking: "normal",
          dataLabels: {
            enabled: false,
          },
          groupPadding: 0.15,
          pointPadding: 0.05,
          borderWidth: 0.05,
        },
        series: {
          point: {
            events: {
              mouseOver: function () {
                const chart = this.series.chart;
                const labelEl =
                  chart.xAxis[0].labelGroup.element.children[this.index];
                if (labelEl) {
                  labelEl.style.transition = "all 0.2s ease";
                  labelEl.style.fontSize = "12px";
                  labelEl.style.fill = "#2E1D51";
                  labelEl.style.fontWeight = "bold";
                }
              },
              mouseOut: function () {
                const chart = this.series.chart;
                const labelEl =
                  chart.xAxis[0].labelGroup.element.children[this.index];
                if (labelEl) {
                  labelEl.style.fontSize = "10px";
                  labelEl.style.fill = "#000000";
                  labelEl.style.fontWeight = "bold";
                }
              },
            },
          },
        },
      },
      series: series,
    }),
    [series, geneCancer]
  );

  const { maleData, femaleData, categories } = useMemo(() => {
    if (!genderAgeGroup)
      return { maleData: [], femaleData: [], categories: [] };

    const totalMale = genderAgeGroup.reduce(
      (sum, entry) => sum + entry.Male,
      0
    );
    const totalFemale = genderAgeGroup.reduce(
      (sum, entry) => sum + entry.Female,
      0
    );
    const totalPopulation = totalMale + totalFemale;

    const categories = genderAgeGroup.map((entry) => entry.ageGroup);

    const maleData = genderAgeGroup.map((entry) => ({
      y: -((entry.Male / totalPopulation) * 100),
      rawValue: entry.Male,
      ageGroup: entry.ageGroup,
      percentage: (entry.Male / totalPopulation) * 100,
    }));

    const femaleData = genderAgeGroup.map((entry) => ({
      y: (entry.Female / totalPopulation) * 100,
      rawValue: entry.Female,
      ageGroup: entry.ageGroup,
      percentage: (entry.Female / totalPopulation) * 100,
    }));

    return { maleData, femaleData, categories };
  }, [genderAgeGroup]);

  const genderage = useMemo(
    () => ({
      accessibility: {
        enabled: false,
      },
      chart: {
        type: "bar",
      },
      credits: {
        enabled: false,
      },
      title: {
        text: "",
      },
      xAxis: [
        {
          categories: categories,
          reversed: false,
          labels: { step: 1 },
          accessibility: { description: "Age (male)" },
        },
        {
          opposite: true,
          reversed: false,
          categories: categories,
          linkedTo: 0,
          labels: { step: 1 },
          accessibility: { description: "Age (female)" },
        },
      ],
      yAxis: {
        title: { text: null },
        labels: {
          formatter: function () {
            return Math.round(Math.abs(this.value)) + "%";
          },
        },
        accessibility: {
          description: "Percentage population",
          rangeDescription: "Range: 0 to 100%",
        },
      },
      plotOptions: {
        series: {
          stacking: "normal",
          borderRadius: "50%",
        },
      },
      tooltip: {
        formatter: function () {
          return `<b>${this.series.name}</b><br/>
            Age Group: ${this.point.ageGroup}<br/>
            ${this.point.rawValue} (${Math.abs(this.point.y).toFixed(2)}%)`;
        },
      },
      series: [
        {
          name: "Male",
          data: maleData,
          color: "#1E4E69",
        },
        {
          name: "Female",

          data: femaleData,
          color: "#8fa7b4",
        },
      ],
    }),
    [categories, maleData, femaleData]
  );

  const zValues = useMemo(() => [
    700, 610, 500, 470, 430, 430, 390, 350, 300, 310, 270, 238, 224, 210, 198,
    141, 136, 131, 118, 110, 95, 60, 30,
  ], []);

  const topcansites = useMemo(
    () => ({
      accessibility: {
        enabled: false,
      },
      chart: {
        type: "variablepie",
        align: "center",
        verticalAlign: "middle",
      },
      title: {
        text: "",
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return (
            '<div style="background-color:' +
            this.point.color +
            '; color: white; padding: 8px; border-radius: 4px;">' +
            this.point.name +
            ": " +
            this.y +
            "<br/>" +
            this.point.percentage.toFixed(2) +
            "%" +
            "</div>"
          );
        },
      },
      credits: {
        enabled: false,
      },

      series: [
        {
          minPointSize: 10,
          innerSize: "20%",
          zMin: 0,
          name: "Cancer Sites",
          borderRadius: 4,
          dataLabels: [
            {
              enabled: true,
              distance: 10,
              padding: -1,
              formatter: function () {
                const maxLength = 12;
                const name = this.point.name;
                const truncatedName =
                  name.length > maxLength
                    ? name.substring(0, maxLength) + "..."
                    : name;
                return this.point.index < 9
                  ? `${truncatedName}: ${this.point.y}`
                  : null;
              },
            },
            {
              enabled: true,
              distance: -55,
              inside: true,
              rotationMode: "auto",
              padding: -3,
              format: "{point.percentage:.0f}%",
              filter: {
                property: "percentage",
                operator: ">",
                value: 4,
              },
              style: {
                fontSize: "0.7em",
                textOutline: "none",
              },
              formatter: function () {
                const fontSize = Math.min(0.9, 0.9 * (this.percentage / 100));
                return `<div style="font-size: ${fontSize}em">${Math.round(
                  this.percentage
                )}%</div>`;
              },
              allowOverlap: false,
              crop: false,
            },
          ],
          showInLegend: false,
          data: cancerSiteTop10Data?.map((site, index) => {
            const zIndex = Math.floor(index / 3);
            return {
              name: site.name,
              y: site.value,
              z: zValues[zIndex] || 0,
            };
          }),
          colors: cancerSiteTop10Data?.map(
            (entry, index) => colors9[Math.floor(index / 3) % colors9.length]
          ),
        },
      ],
    }),
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
    [cancerSiteTop10Data]
  );

  const resofcansites = useMemo(
    () => ({
      accessibility: {
        enabled: false,
      },
      chart: {
        type: "variablepie",
        verticalAlign: "middle",
        align: "center",
      },
      title: {
        text: "",
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return (
            '<div style="background-color:' +
            this.point.color +
            '; color: white; padding: 8px; border-radius: 4px;">' +
            this.point.name +
            ": " +
            this.y +
            "<br/>" +
            this.point.percentage.toFixed(2) +
            "%" +
            "</div>"
          );
        },
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        variablepie: {
          dataLabels: [
            {
              enabled: true,
              distance: 10,
              padding: -1,
              formatter: function () {
                const maxLength = 12;
                const name = this.point.name;
                const truncatedName =
                  name.length > maxLength
                    ? name.substring(0, maxLength) + "..."
                    : name;
                return this.point.index < 20
                  ? `${truncatedName}: ${this.point.y}`
                  : null;
              },
            },
            {
              enabled: true,
              distance: -45,
              rotationMode: "auto",
              padding: -5,
              format: "{point.percentage:.0f}%",
              filter: {
                property: "percentage",
                operator: ">",
                value: 4,
              },
              style: {
                fontSize: "0.6em",
                textOutline: "none",
                textOverflow: "none",
              },
              formatter: function () {
                const percentage = Math.round(this.percentage);
                const fontSize = Math.max(0.4, Math.min(0.6, percentage / 20));
                return `<div style="font-size: ${fontSize}rem;">${percentage}%</div>`;
              },

              allowOverlap: false,
              crop: false,
              inside: true,
            },
          ],
        },
      },
      series: [
        {
          minPointSize: 10,
          innerSize: "25%",
          zMin: 0,
          name: "Cancer Sites",
          borderWidth: 0.08,
          borderRadius: 4,
          data: cancerSiteRestOfData?.map((site, index) => {
            const zIndex = Math.floor(index / 4);
            return {
              name: site.name,
              y: site.value,
              z: zValues[zIndex] || 0,
              index: index,
            };
          }),
          colors: cancerSiteRestOfData?.map(
            (entry, index) => colors4[Math.floor(index / 3) % colors4.length]
          ),
        },
      ],
    }),
    [cancerSiteRestOfData, zValues]
  );

  const morphPie = useMemo(
    () => ({
      accessibility: {
        enabled: false,
      },
      chart: {
        type: "variablepie",
        align: "center",
        verticalAlign: "middle",
        height: 500,
      },
      title: {
        text: "",
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return (
            '<div style="background-color:' +
            this.point.color +
            '; color: white; padding: 8px; border-radius: 4px;">' +
            this.point.name +
            ": " +
            this.y +
            "<br/>" +
            this.point.percentage.toFixed(2) +
            "%" +
            "</div>"
          );
        },
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        variablepie: {
          dataLabels: [
            {
              enabled: true,
              distance: 25,
              padding: -1,
              style: {
                fontSize: '14px',
                textOutline: 'none'
              },
              formatter: function () {
                const maxLength = 16;
                const name = this.point.name;
                const truncatedName =
                  name.length > maxLength
                    ? name.substring(0, maxLength) + "..."
                    : name;
                return this.point.index < 20
                  ? `${truncatedName}: ${this.point.y}`
                  : null;
              },
            },
            {
              enabled: true,
              distance: -45,
              rotationMode: "auto",
              padding: -5,
              format: "{point.percentage:.0f}%",
              filter: {
                property: "percentage",
                operator: ">",
                value: 4,
              },
              style: {
                fontSize: "0.6em",
                textOutline: "none",
                textOverflow: "none",
              },
              formatter: function () {
                const percentage = Math.round(this.percentage);
                const fontSize = Math.max(0.4, Math.min(0.6, percentage / 20));
                return `<div style="font-size: ${fontSize}rem;">${percentage}%</div>`;
              },

              allowOverlap: false,
              crop: false,
              inside: true,
            },
          ],
        },
      },
      series: [
        {
          minPointSize: 10,
          innerSize: "25%",
          zMin: 0,
          name: "morphology types",
          borderWidth: 0.08,
          borderRadius: 4,
          data: morphologyData?.map((site, index) => {
            const zIndex = Math.floor(index / 4);
            return {
              name: site.name,
              y: site.value,
              z: zValues[zIndex] || 0,
              index: index,
            };
          }),
          colors: morphologyData?.map(
            (entry, index) => colors4[Math.floor(index / 3) % colors4.length]
          ),
        },
      ],
    }),
    [morphologyData, zValues]
  );
  const testTypePie = useMemo(
    () => ({
      accessibility: {
        enabled: false,
      },
      chart: {
        type: "variablepie",
        align: "center",
        verticalAlign: "middle",
        height: 500,
      },
      title: {
        text: "",
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return (
            '<div style="background-color:' +
            this.point.color +
            '; color: white; padding: 8px; border-radius: 4px;">' +
            this.point.name +
            ": " +
            this.y +
            "<br/>" +
            this.point.percentage.toFixed(2) +
            "%" +
            "</div>"
          );
        },
      },
      credits: {
        enabled: false,
      },
      plotOptions: {
        variablepie: {
          dataLabels: [
            {
              enabled: true,
              distance: 10,
              padding: -1,
              formatter: function () {
                const maxLength = 3;
                const name = this.point.name;
                const truncatedName =
                  name.length > maxLength
                    ? name.substring(0, maxLength) + "..."
                    : name;
                return this.point.index < 20
                  ? `${truncatedName}: ${this.point.y}`
                  : null;
              },
            },
            {
              enabled: true,
              distance: -45,
              rotationMode: "auto",
              padding: -5,
              format: "{point.percentage:.0f}%",
              filter: {
                property: "percentage",
                operator: ">",
                value: 4,
              },
              style: {
                fontSize: "0.6em",
                textOutline: "none",
                textOverflow: "none",
              },
              formatter: function () {
                const percentage = Math.round(this.percentage);
                const fontSize = Math.max(0.4, Math.min(0.6, percentage / 20));
                return `<div style="font-size: ${fontSize}rem;">${percentage}%</div>`;
              },

              allowOverlap: false,
              crop: false,
              inside: true,
            },
          ],
        },
      },
      series: [
        {
          minPointSize: 10,
          innerSize: "25%",
          zMin: 0,
          name: "Cancer Sites",
          borderWidth: 0.08,
          borderRadius: 4,
          data: testTypeGraphData?.map((site, index) => {
            const zIndex = Math.floor(index / 4);
            return {
              name: site.name,
              y: site.value,
              z: zValues[zIndex] || 0,
              index: index,
            };
          }),
          colors: testTypeGraphData?.map(
            (entry, index) => colors4[Math.floor(index / 3) % colors4.length]
          ),
        },
      ],
    }),
    [testTypeGraphData, zValues]
  );

  const targtedDrugoptions = useMemo(
    () => ({
      chart: {
        type: "pie",
        custom: {},
      },
      exporting: {
        enabled: false,
      },
      accessibility: {
        enabled: false,
        point: {
          valueSuffix: "%",
        },
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        //padding: 8,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return `
    <div class="dashboard-tooltip" style="background-color:${this.point.color}">
        <div class="dashboard-tooltip-label">${this.point.name}:</div>
        <div class="dashboard-tooltip-value">
          ${this.y} (${this.point.percentage.toFixed(2)}%)
        </div>
      </div>
  `;
        },
        style: {
          color: "white",
          borderWidth: 0,
        },
      },
      legend: {
        symbolWidth: 16,
        symbolRadius: 4,
        //  rectangleSymbol:true
        squareSymbol: false,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          borderRadius: 5,
          size: "70%",

          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: "{point.name}",
            },
            {
              enabled: true,
              distance: -23,
              format: "{point.percentage:.0f}%",
              style: {
                fontSize: "0.8em",
                textOutline: "none",
              },
            },
          ],
          showInLegend: true,
          colors: targetedTherapy?.map(
            (entry, index) => colors7[index % colors7.length]
          ),
        },
      },
      series: [
        {
          colorByPoint: true,
          innerSize: "55%",
          data: targetedTherapy?.map((obj) => ({
            name: obj.name,
            y: obj.value,
          })),
        },
      ],
    }),
    [targetedTherapy]
  );

  const immunooptions = useMemo(
    () => ({
      chart: {
        type: "pie",
        custom: {},
      },
      exporting: {
        enabled: false,
      },
      accessibility: {
        enabled: false,
        point: {
          valueSuffix: "%",
        },
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        //padding: 8,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return `
    <div class="dashboard-tooltip" style="background-color:${this.point.color}">
        <div class="dashboard-tooltip-label">${this.point.name}:</div>
        <div class="dashboard-tooltip-value">
          ${this.y} (${this.point.percentage.toFixed(2)}%)
        </div>
      </div>
  `;
        },
        style: {
          color: "white",
          borderWidth: 0,
        },
      },
      legend: {
        symbolWidth: 16,
        symbolRadius: 4,
        squareSymbol: false,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          borderRadius: 5,
          size: "70%",

          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: "{point.name}",
            },
            {
              enabled: true,
              distance: -23,
              format: "{point.percentage:.0f}%",
              style: {
                fontSize: "0.8em",
                textOutline: "none",
              },
            },
          ],
          showInLegend: true,
          colors: drugsCount?.map(
            (entry, index) => colors7[index % colors7.length]
          ),
        },
      },
      series: [
        {
          colorByPoint: true,
          innerSize: "55%",
          data: drugsCount?.map((obj) => ({ name: obj.name, y: obj.value })),
        },
      ],
    }),
    [drugsCount]
  );
  const treatmentResponse = useMemo(
    () => ({
      chart: {
        type: "pie",
        custom: {},
      },
      exporting: {
        enabled: false,
      },
      accessibility: {
        enabled: false,
        point: {
          valueSuffix: "%",
        },
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return `
    <div class="dashboard-tooltip" style="background-color:${this.point.color}">
        <div class="dashboard-tooltip-label">${this.point.name}:</div>
        <div class="dashboard-tooltip-value">
          ${this.y} (${this.point.percentage.toFixed(2)}%)
        </div>
      </div>
  `;
        },
        style: {
          color: "white",
          borderWidth: 0,
        },
      },
      legend: {
        symbolWidth: 16,
        symbolRadius: 4,
        squareSymbol: false,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          borderRadius: 5,
          size: "70%",

          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: "{point.name}",
            },
            {
              enabled: true,
              distance: -23,
              format: "{point.percentage:.0f}%",
              style: {
                fontSize: "0.8em",
                textOutline: "none",
              },
            },
          ],
          showInLegend: true,
          colors: recistCriteria?.map(
            (entry, index) => colors7[index % colors7.length]
          ),
        },
      },
      series: [
        {
          colorByPoint: true,
          innerSize: "55%",
          data: recistCriteria?.map((obj) => ({
            name: obj.name,
            y: obj.value,
          })),
        },
      ],
    }),
    [recistCriteria]
  );

  const druggoptions = useMemo(
    () => ({
      accessibility: {
        enabled: false,
        point: {
          valueSuffix: "%",
        },
      },
      chart: {
        type: "pie",
        custom: {},
      },
      exporting: {
        enabled: false,
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return `
    <div class="dashboard-tooltip" style="background-color:${this.point.color}">
        <div class="dashboard-tooltip-label">${this.point.name}:</div>
        <div class="dashboard-tooltip-value">
          ${this.y} (${this.point.percentage.toFixed(2)}%)
        </div>
      </div>
  `;
        },
        style: {
          color: "white",
          borderWidth: 0,
        },
      },
      legend: {
        symbolWidth: 16,
        symbolRadius: 4,
        squareSymbol: false,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          borderRadius: 5,
          size: "70%",

          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: "{point.name}",
            },
            {
              enabled: true,
              distance: -23,
              format: "{point.percentage:.0f}%",
              style: {
                fontSize: "0.8em",
                textOutline: "none",
              },
            },
          ],
          showInLegend: true,
          colors: drugTherapy?.map(
            (entry, index) => colors7[index % colors7.length]
          ),
        },
      },
      series: [
        {
          colorByPoint: true,
          innerSize: "55%",
          data: drugTherapy?.map((obj) => ({ name: obj.name, y: obj.value })),
        },
      ],
    }),
    [drugTherapy]
  );
  const biooptions = useMemo(
    () => ({
      accessibility: {
        enabled: false,
        point: {
          valueSuffix: "%",
        },
      },
      chart: {
        type: "pie",
        custom: {},
      },
      exporting: {
        enabled: false,
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return `
    <div class="dashboard-tooltip" style="background-color:${this.point.color}">
        <div class="dashboard-tooltip-label">${this.point.name}:</div>
        <div class="dashboard-tooltip-value">
          ${this.y} (${this.point.percentage.toFixed(2)}%)
        </div>
      </div>
  `;
        },
        style: {
          color: "white",
          borderWidth: 0,
        },
      },
      legend: {
        symbolWidth: 16,
        symbolRadius: 4,
        squareSymbol: false,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          borderRadius: 5,
          size: "70%",

          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: "{point.name}",
            },
            {
              enabled: true,
              distance: -25,
              format: "{point.percentage:.0f}%",
              style: {
                fontSize: "0.8em",
                textOutline: "none",
              },
            },
          ],
          showInLegend: true,
          colors: biologicalTherapy?.map(
            (entry, index) => colors7[index % colors7.length]
          ),
        },
      },
      series: [
        {
          colorByPoint: true,
          innerSize: "55%",
          data: biologicalTherapy?.map((obj) => ({
            name: obj.name,
            y: obj.value,
          })),
        },
      ],
    }),
    [biologicalTherapy]
  );

  const treatmentoptions = useMemo(
    () => ({
      accessibility: {
        enabled: false,
        point: {
          valueSuffix: "%",
        },
      },
      chart: {
        type: "pie",
        custom: {},
      },
      exporting: {
        enabled: false,
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return `
    <div class="dashboard-tooltip" style="background-color:${this.point.color}">
        <div class="dashboard-tooltip-label">${this.point.name}:</div>
        <div class="dashboard-tooltip-value">
          ${this.y} (${this.point.percentage.toFixed(2)}%)
        </div>
      </div>
  `;
        },
        style: {
          color: "white",
          borderWidth: 0,
        },
      },
      legend: {
        symbolWidth: 16,
        symbolRadius: 4,
        squareSymbol: false,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          borderRadius: 5,
          size: "70%",

          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: "{point.name}",
            },
            {
              enabled: true,
              distance: -25,
              format: "{point.percentage:.0f}%",
              style: {
                fontSize: "0.8em",
                textOutline: "none",
              },
            },
          ],
          showInLegend: true,
          colors: treatmentDetails?.map(
            (entry, index) => colors7[index % colors7.length]
          ),
        },
      },
      series: [
        {
          colorByPoint: true,
          innerSize: "55%",
          data: treatmentDetails?.map((obj) => ({
            name: obj.name,
            y: obj.value,
          })),
        },
      ],
    }),
    [treatmentDetails]
  );

  const tmboptions = useMemo(
    () => ({
      chart: {
        type: "pie",
        custom: {},
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
          },
        },
      },
      accessibility: {
        enabled: false,
        point: {
          valueSuffix: "%",
        },
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return (
            '<div style="background-color:' +
            this.point.color +
            '">' +
            this.point.name +
            ": " +
            this.y +
            "<br/>" +
            this.point.percentage.toFixed(2) +
            "%</div>"
          );
        },
        style: {
          color: "white",
          borderWidth: 0,
        },
      },
      legend: {
        symbolWidth: 16,
        symbolRadius: 4,
        squareSymbol: false,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          borderRadius: 5,
          size: "70%",

          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: "{point.name}",
            },
            {
              enabled: true,
              distance: -27,
              formatter: function () {
                return this.point.percentage > 2
                  ? `${Math.round(this.point.percentage)}%`
                  : null;
              },
              style: {
                fontSize: "0.8em",
                textOutline: "none",
              },
            },
          ],
          showInLegend: true,
          colors: tmbData?.map(
            (entry, index) =>
              tmbmsipdlcolors[tmbData.indexOf(entry) % tmbmsipdlcolors.length]
          ),
        },
      },
      series: [
        {
          colorByPoint: true,
          innerSize: "55%",
          data: tmbData?.map((obj) => ({ name: obj.name, y: obj.value })),
        },
      ],
    }),
    [tmbData]
  );
  const msioptions = useMemo(
    () => ({
      chart: {
        type: "pie",
        custom: {},
      },
      exporting: {
        enabled: false,
      },
      accessibility: {
        enabled: false,
        point: {
          valueSuffix: "%",
        },
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return (
            '<div style="background-color:' +
            this.point.color +
            '">' +
            this.point.name +
            ": " +
            this.y +
            "<br/>" +
            this.point.percentage.toFixed(2) +
            "%</div>"
          );
        },
        style: {
          color: "white",
          borderWidth: 0,
        },
      },
      legend: {
        symbolWidth: 16,
        symbolRadius: 4,
        squareSymbol: false,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          borderRadius: 5,
          size: "70%",

          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: "{point.name}",
            },
            {
              enabled: true,
              distance: -25,
              formatter: function () {
                return this.point.percentage > 2
                  ? `${Math.round(this.point.percentage)}%`
                  : null;
              },
              style: {
                fontSize: "0.8em",
                textOutline: "none",
              },
            },
          ],
          showInLegend: true,
          colors: msiData?.map(
            (entry, index) =>
              tmbmsipdlcolors[msiData.indexOf(entry) % tmbmsipdlcolors.length]
          ),
        },
      },
      series: [
        {
          colorByPoint: true,
          innerSize: "55%",
          data: msiData?.map((obj) => ({ name: obj.name, y: obj.value })),
        },
      ],
    }),
    [msiData]
  );
  const pdloptions = useMemo(
    () => ({
      chart: {
        type: "pie",
        custom: {},
      },
      exporting: {
        enabled: false,
      },
      accessibility: {
        enabled: false,
        point: {
          valueSuffix: "%",
        },
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return (
            '<div style="background-color:' +
            this.point.color +
            '">' +
            this.point.name +
            ": " +
            this.y +
            "<br/>" +
            this.point.percentage.toFixed(2) +
            "%</div>"
          );
        },
        style: {
          color: "white",
          borderWidth: 0,
        },
      },
      legend: {
        symbolWidth: 16,
        symbolRadius: 4,
        squareSymbol: false,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          borderRadius: 5,
          size: "70%",

          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: "{point.name}",
            },
            {
              enabled: true,
              distance: -26,
              format: "{point.percentage:.0f}%",
              style: {
                fontSize: "0.8em",
                textOutline: "none",
              },
            },
          ],
          showInLegend: true,
          colors: pdlData?.map(
            (entry, index) =>
              tmbmsipdlcolors[pdlData.indexOf(entry) % tmbmsipdlcolors.length]
          ),
        },
      },
      series: [
        {
          colorByPoint: true,
          innerSize: "55%",
          data: pdlData?.map((obj) => ({ name: obj.name, y: obj.value })),
        },
      ],
    }),
    [pdlData]
  );


  const varianttype = useMemo(
    () => ({
      chart: {
        type: "pie",
        align: "center",
        verticalAlign: "middle",
        height: 500,
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
          },
        },
      },
      accessibility: {
        enabled: false,
        point: {
          valueSuffix: "%",
        },
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return (
            '<div style="background-color:' +
            this.point.color +
            '">' +
            this.point.name +
            ": " +
            this.y +
            "<br/>" +
            this.point.percentage.toFixed(2) +
            "%</div>"
          );
        },
        style: {
          color: "white",
          borderWidth: 0,
        },
      },
      legend: {
        symbolWidth: 16,
        symbolRadius: 4,
        squareSymbol: false,
        enabled: false,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          borderRadius: 4,
          borderWidth: 0.05,
          size: "70%",

          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: "{point.name}",
            },
            {
              enabled: true,
              distance: -27,
              formatter: function () {
                return this.point.percentage > 2
                  ? `${Math.round(this.point.percentage)}%`
                  : null;
              },
              style: {
                fontSize: "0.7em",
                textOutline: "none",
              },
            },
          ],

          showInLegend: true,
          colors: variantTypeResponse?.map(
            (entry, index) => colors4[index % colors4.length]
          ),
        },
      },
      series: [
        {
          colorByPoint: true,
          innerSize: "50%",
          data: variantTypeResponse?.map((obj) => ({
            name: obj.name,
            y: obj.value,
          })),
        },
      ],
    }),
    [variantTypeResponse]
  );

  const cancerstagegraph = useMemo(
    () => ({
      chart: {
        type: "pie",
        custom: {},
      },
      exporting: {
        enabled: true,
        buttons: {
          contextButton: {
            enabled: false,
          },
        },
      },
      accessibility: {
        enabled: false,
        point: {
          valueSuffix: "%",
        },
      },
      title: {
        text: "",
      },
      credits: {
        enabled: false,
      },
      tooltip: {
        backgroundColor: "none",
        borderRadius: 0,
        shadow: false,
        useHTML: true,
        borderWidth: 0,
        formatter: function () {
          return (
            '<div style="background-color:' +
            this.point.color +
            '">' +
            this.point.name +
            ": " +
            this.y +
            "<br/>" +
            this.point.percentage.toFixed(2) +
            "%</div>"
          );
        },
        style: {
          color: "white",
          borderWidth: 0,
        },
      },
      legend: {
        symbolWidth: 16,
        symbolRadius: 4,
        squareSymbol: false,
        enabled: false,
      },
      plotOptions: {
        series: {
          allowPointSelect: true,
          cursor: "pointer",
          borderRadius: 4,
          borderWidth: 0.05,
          size: "70%",

          dataLabels: [
            {
              enabled: true,
              distance: 20,
              format: "{point.name}",
            },
            {
              enabled: true,
              distance: -27,
              formatter: function () {
                return this.point.percentage > 2
                  ? `${Math.round(this.point.percentage)}%`
                  : null;
              },
              style: {
                fontSize: "0.7em",
                textOutline: "none",
              },
            },
          ],

          showInLegend: true,
          colors: cancerStage?.map(
            (entry, index) => colors4[index % colors4.length]
          ),
        },
      },
      series: [
        {
          colorByPoint: true,
          innerSize: "55%",
          data: cancerStage?.map((obj) => ({ name: obj.name, y: obj.value })),
        },
      ],
    }),
    [cancerStage]
  );

  const handleClearAll = useCallback(() => {
    setFromError("");
    setToError("");
    setSelectedQuickRange("");
    if (fromDate !== null || fromDraft !== null) {
      setFromDate(null);
      setFromDraft(null);
    }
    if (toDate !== null || toDraft !== null) {
      setToDate(null);
      setToDraft(null);
    }
    if (!wasManuallyCleared) setWasManuallyCleared(true);

    if (cancerFilterVal1.length > 0) setCancerFilterVal1([]);
    if (selectedGenes.length > 0) setSelectedGenes([]);
    if (immunoFilter.length > 0) setImmunoFilter([]);
    if (targetedFilter.length > 0) setTargetedFilter([]);
    if (morphologyFilterVal.length > 0) setMorphologyFilterVal([]);
    if (doctorsDropdownDataFilter.length > 0) setDoctorsDropdownDataFilter([]);

    if (searchTermForImmuno !== "") setSearchTermForImmuno("");
    if (seacrhTermForTargeted !== "") setSeacrhTermForTargeted("");
    if (searchTermForGene !== "") setSearchTermForGene("");
    if (searchTermForCancer !== "") setSearchTermForCancer("");
    if (searchTermForMorphology !== "") setSearchTermForMorphology("");
    if (searchTermForDoctor !== "") setSearchTermForDoctor("");

    if (citiesFilter.length > 0) setCitiesFilter([]);
    if (hospitalsFilter.length > 0) setHospitalsFilter([]);

    if (isPdlChecked !== false) setIsPdlChecked(false);
    if (ngsValue !== null) setNgsValue(null);
    if (geneDetectionStatus !== null) setGeneDetectionStatus(null);
    if (testTypeFilter.length > 0) setTestTypeFilter([]);
    if (genderFilter.length > 0) setGenderFilter([]);
    if (clinicalSignificanceFilter.length > 0 ) setClinicalSignificanceFilter([]);
  }, [fromDate, setFromDate, toDate, setToDate, wasManuallyCleared,
     setWasManuallyCleared, cancerFilterVal1.length, setCancerFilterVal1,
      selectedGenes.length, setSelectedGenes, immunoFilter.length, setImmunoFilter,
      targetedFilter.length, setTargetedFilter, morphologyFilterVal.length,
      setMorphologyFilterVal, doctorsDropdownDataFilter.length, setDoctorsDropdownDataFilter,
      searchTermForImmuno, seacrhTermForTargeted, searchTermForGene, searchTermForCancer,
      searchTermForMorphology, searchTermForDoctor, citiesFilter.length, setCitiesFilter,
       hospitalsFilter.length, setHospitalsFilter, isPdlChecked, setIsPdlChecked, ngsValue,
       clinicalSignificanceFilter,
        setNgsValue, geneDetectionStatus, setGeneDetectionStatus, testTypeFilter.length, setTestTypeFilter, fromDraft, toDraft]);


  const filteredSites = useMemo(() => {
    if (!debouncedSearchTerm) return cancerDropdown;

    return cancerDropdown
      .map(group => {
        const matchedSites = group.matchedSites.filter(site =>
          site.name.toLowerCase().includes(debouncedSearchTerm.toLowerCase())
        );

        if (matchedSites.length > 0) {
          return { ...group, matchedSites };
        }
        return null;
      })
      .filter(Boolean);
  }, [cancerDropdown, debouncedSearchTerm]);

  const filteredMorphology = useMemo(() => {
    return morphologyDropdown?.filter((mtype) =>
      mtype?.name.toLowerCase().includes(searchTermForMorphology?.toLowerCase())
    );
  }, [morphologyDropdown, searchTermForMorphology]);

  const filteredSites1 = useMemo(() => {
    return immunoFilterData?.filter((site) =>
      site?.name?.toLowerCase().includes(searchTermForImmuno?.toLowerCase())
    );
  }, [immunoFilterData, searchTermForImmuno]);

  const normalizedSearch = useMemo(
    () => searchTermForGene?.toLowerCase().trim() || "",
    [searchTermForGene]
  );
  const filteredSites2 = useMemo(() => {
    return geneCancerAllDataList?.filter((site) =>
      site?.biomarkerName?.toLowerCase().includes(normalizedSearch)
    ) || [];
  }, [geneCancerAllDataList, normalizedSearch]);

  const clinicallfiltered = useMemo(() => {
    return clinicalSignificanceDropdown?.filter((site) =>
      site?.name?.toLowerCase().includes(searchTermForClinical.toLowerCase())
    ) || [];
  }, [clinicalSignificanceDropdown, searchTermForClinical]);


  const filteredSites3 = useMemo(() => {
    return citiesFilterData?.filter((site) =>
      site?.name?.toLowerCase().includes(searchTermForCities?.toLowerCase())
    );
  }, [citiesFilterData, searchTermForCities]);

  const filteredSites4 = useMemo(() => {
    return hospitalsFilterData?.filter((site) =>
      site?.name?.toLowerCase().includes(searchTermForHospitals?.toLowerCase())
    );
  }, [hospitalsFilterData, searchTermForHospitals]);

  const targetedTherapyfiltered = useMemo(() => {
    return (
      targetedFilterData?.filter((site) =>
        site?.name
          ?.toLowerCase()
          .includes(seacrhTermForTargeted?.toLowerCase() || "")
      ) || []
    );
  }, [targetedFilterData, seacrhTermForTargeted]);



  const debouncedDoctorFilter = useMemo(
    () =>
      debounce((term, doctors) => {
        const trimmedTerm = term?.trim().toLowerCase();

        if (!trimmedTerm) {
          setFilteredDoctors(doctors);
          return;
        }

        const filtered = doctors.filter((doc) =>
          doc.name.toLowerCase().includes(trimmedTerm)
        );
        setFilteredDoctors(filtered);
      }, 300),
    []
  );

  const handleDoctorSearchChange = (e) => {
    const value = e.target.value;
    setSearchTermForDoctor(value);
    debouncedDoctorFilter(value, doctorsDropdownData);
  };


  const debouncedTestypeFilter = useMemo(
    () =>
      debounce((term, test) => {
        const trimmedTerm = term?.trim().toLowerCase();
        if (!trimmedTerm) {
          setFilteredTestTypes(test);
          return;
        }

        const filtered = test.filter((type) =>
          type.name.toLowerCase().includes(trimmedTerm)
        );
        setFilteredTestTypes(filtered);
      }, 300),
    []
  );

  const handleTestypeSearchChange = (e) => {
    const value = e.target.value;
    setsearchTermForTestType(value);
    debouncedTestypeFilter(value, testTypeFilterData);
  };

  const selectedVisibleMorphCount = useMemo(() => {
    return morphologyFilterVal.filter((morph) =>
      filteredMorphology.some((f) => f.name === morph.name)
    ).length;
  }, [morphologyFilterVal, filteredMorphology]);

  const handleSelectAllGroup = useCallback((group) => {
    setCancerFilterVal1(prev => {
      const groupSiteNames = group.matchedSites.map(site => site.name);
      const allSelected = groupSiteNames.every(site => prev.includes(site));

      if (allSelected) {
        return prev.filter(site => !groupSiteNames.includes(site));
      } else {
        const missingSites = groupSiteNames.filter(site => !prev.includes(site));
        return Array.from(new Set([...prev, ...missingSites]));
      }
    });
  }, [setCancerFilterVal1]);
  const toggleSite = useCallback((groupName, siteName) => {
    setCancerFilterVal1(prev => {
      const current = Array.isArray(prev) ? prev : [];
      const isSelected = current.includes(siteName);

      if (isSelected && siteName === "Lung") {
        setWasManuallyCleared(true);
      }

      const updated = isSelected
        ? current.filter(s => s !== siteName)
        : [...current, siteName];

      return updated;
    });
  }, [setCancerFilterVal1, setWasManuallyCleared]);

  const toggleGroup = useCallback((groupName) => {
    setOpenGroups((prev) => ({
      ...prev,
      [groupName]: !prev[groupName],
    }));
  }, [setOpenGroups]);

  const selectedCategoryCount = useMemo(() => {
    if (!cancerDropdown || !cancerFilterVal1) return 0;

    return cancerDropdown.reduce((count, group) => {
      const matchedSites = group.matchedSites || [];
      const isGroupSelected = matchedSites.some((site) =>
        cancerFilterVal1.includes(site.name)
      );
      return isGroupSelected ? count + 1 : count;
    }, 0);
  }, [cancerDropdown, cancerFilterVal1]);

  const geneDrillDownCount = useMemo(() => {
    let count = 0;

    if (selectedGenes?.length > 0) count += 1;
    if (clinicalSignificanceFilter?.length > 0) count += 1;

    return count;
  }, [selectedGenes, clinicalSignificanceFilter]);

  const handleGeneSelectAll = useCallback(() => {
    const allSelected =
      selectedGenes.length === filteredSites2.length;

    if (allSelected) {
      // deselect all
      setSelectedGenes([]);
    } else {
      // select all
      setSelectedGenes(filteredSites2);
    }
  }, [selectedGenes, filteredSites2]);


  const handleClinicalSelectAll = useCallback(() => {
    const allSelected =
      clinicalSignificanceFilter.length === clinicallfiltered.length;

    if (allSelected) {
      // deselect all
      setClinicalSignificanceFilter([]);
    } else {
      // select all
      setClinicalSignificanceFilter(clinicallfiltered);
    }
  }, [clinicalSignificanceFilter, clinicallfiltered]);



  const handlMorphologySelectAll = useCallback(() => {
    if (!filteredMorphology || filteredMorphology.length === 0) return;

    const map = new Map();

    // Keep already selected
    morphologyFilterVal.forEach((mtype) => {
      if (mtype?.name) map.set(mtype.name, mtype);
    });

    // Add filtered items
    filteredMorphology.forEach((mtype) => {
      if (mtype?.name) map.set(mtype.name, mtype);
    });

    setMorphologyFilterVal(Array.from(map.values()));
  }, [morphologyFilterVal, filteredMorphology, setMorphologyFilterVal]);

  const handleTestTypeSelectAll = useCallback(() => {
    const map = new Map(testTypeFilter?.map((site) => [site.name, site]));
    filteredTestTypes.forEach((site) => {
      map.set(site.name, site);
    });
    setTestTypeFilter(Array.from(map.values()));
  }, [testTypeFilter, filteredTestTypes, setTestTypeFilter]);

  const handleImmunoSelectAll = useCallback(() => {
    const map = new Map(immunoFilter.map((site) => [site.name, site]));
    filteredSites1.forEach((site) => {
      map.set(site.name, site);
    });
    setImmunoFilter(Array.from(map.values()));
  }, [immunoFilter, filteredSites1, setImmunoFilter]);

  const handleTargetedSelectAll = useCallback(() => {
    const map = new Map(targetedFilter.map((site) => [site.name, site]));
    targetedTherapyfiltered.forEach((site) => {
      map.set(site.name, site);
    });
    setTargetedFilter(Array.from(map.values()));
  }, [targetedFilter, targetedTherapyfiltered, setTargetedFilter]);

  const handleHospitalsSelectAll = useCallback(() => {
    const map = new Map(
      hospitalsFilter?.map((hospital) => [hospital.name, hospital])
    );
    filteredSites4.forEach((hospital) => {
      map.set(hospital.name, hospital);
    });
    setHospitalsFilter(Array.from(map.values()));
  }, [hospitalsFilter, filteredSites4, setHospitalsFilter]);

  const handleDoctorSelectAll = useCallback(() => {
    const map = new Map(doctorsDropdownDataFilter?.map(doctor => [doctor.name, doctor]));
    filteredDoctors.forEach(doctor => {
      map.set(doctor.name, doctor);
    });
    setDoctorsDropdownDataFilter(Array.from(map.values()));
  }, [doctorsDropdownDataFilter, filteredDoctors, setDoctorsDropdownDataFilter]);

  const handleCitiesSelectAll = useCallback(() => {
    const map = new Map(citiesFilter?.map((city) => [city.name, city]));
    filteredSites3.forEach((city) => {
      map.set(city.name, city);
    });
    setCitiesFilter(Array.from(map.values()));
  }, [citiesFilter, filteredSites3, setCitiesFilter]);

  const handleClear = () => {
    setWasManuallyCleared(true);
    setCancerFilterVal1([]);
    setSearchTermForCancer("");
  };

  const toggleGene = useCallback(
    (gene) => {
      setSelectedGenes((prev) =>
        prev.some((item) => item.biomarkerName === gene.biomarkerName)
          ? prev.filter((item) => item.biomarkerName !== gene.biomarkerName)
          : [...prev, gene]
      );
    },
    [setSelectedGenes]
  );
  const toggleClinicalSignificance = (item) => {
    setClinicalSignificanceFilter((prev) => {
      const exists = prev.some((s) => s.name === item.name);
      if (exists) {
        return prev.filter((s) => s.name !== item.name);
      }
      return [...prev, item];
    });
  };

  const handleGeneClear = () => {
    setSelectedGenes([]);
    setSearchTermForGene("");
  };
  const toggleImmuno = useCallback(
    (item) => {
      setImmunoFilter((prev) =>
        prev.some((i) => i.name === item.name)
          ? prev.filter((i) => i.name !== item.name)
          : [...prev, item]
      );
    },
    [setImmunoFilter]
  );

  const toggleTargeted = useCallback(
    (item) => {
      setTargetedFilter((prev) =>
        prev.some((i) => i.name === item.name)
          ? prev.filter((i) => i.name !== item.name)
          : [...prev, item]
      );
    },
    [setTargetedFilter]
  );
  const toggleGender = useCallback(
    (item) => {
      setGenderFilter((prev) =>
        prev.some((g) => g.name === item.name)
          ? prev.filter((g) => g.name !== item.name)
          : [...prev, item]
      );
    },
    [setGenderFilter]
  );

  const handleGenderSelectAll = useCallback(() => {
    const map = new Map(genderFilter?.map((g) => [g.name, g]));
    genderDropdown?.forEach((g) => map.set(g.name, g));
    setGenderFilter(Array.from(map.values()));
  }, [genderFilter, genderDropdown, setGenderFilter]);

  const handleGenderClear = useCallback(() => {
    setGenderFilter([]);
  }, [setGenderFilter]);

  const toggleMorphology = useCallback(
    (mtype) => {
      setMorphologyFilterVal((prev) => {
        const isSelected = prev.some((item) => item.name === mtype.name);

        if (isSelected && mtype.name === "Lung") {
          setWasManuallyCleared(true);
        }

        return isSelected
          ? prev.filter((item) => item.name !== mtype.name)
          : [...prev, mtype];
      });
    },
    [setMorphologyFilterVal, setWasManuallyCleared]
  );

  const handleMorphologyClear = useCallback(() => {
    setMorphologyFilterVal([]);
    setSearchTermForMorphology("");
  }, [setMorphologyFilterVal, setSearchTermForMorphology]);

  const handleDOctorClear = useCallback(() => {
    setDoctorsDropdownDataFilter([]);
    setSearchTermForDoctor('');
  }, [setDoctorsDropdownDataFilter, setSearchTermForDoctor]);
  ;
  const toggleTestType = useCallback(
    (item) => {
      setTestTypeFilter((prev) =>
        prev.some((i) => i.name === item.name)
          ? prev.filter((i) => i.name !== item.name)
          : [...prev, item]
      );
    },
    [setTestTypeFilter]
  );

  const handleTestTypeClear = useCallback(() => {
    setTestTypeFilter([]);
    setsearchTermForTestType("");
  }, [setTestTypeFilter, setsearchTermForTestType]);

  const handleTargetedClear = useCallback(() => {
    setTargetedFilter([]);
    setSeacrhTermForTargeted("");
  }, [setTargetedFilter, setSeacrhTermForTargeted]);

  const handleImmunoClear = () => {
    setImmunoFilter([]);
    setSearchTermForImmuno("");
  };
  const toggleCities = useCallback(
    (item) => {
      setCitiesFilter((prev) =>
        prev.some((i) => i.name === item.name)
          ? prev.filter((i) => i.name !== item.name)
          : [...prev, item]
      );
    },
    [setCitiesFilter]
  );
  const toggleDoctorDropdown = useCallback((item) => {
    setDoctorsDropdownDataFilter((prev) =>
      prev.some((i) => i.name === item.name)
        ? prev.filter((i) => i.name !== item.name)
        : [...prev, item]
    );
  }, [setDoctorsDropdownDataFilter]);


  const handleCitiesClear = () => {
    setCitiesFilter([]);
    setSeacrhTermForCities("");
  };

  const toggleHospitals = useCallback(
    (item) => {
      setHospitalsFilter((prev) =>
        prev.some((i) => i.name === item.name)
          ? prev.filter((i) => i.name !== item.name)
          : [...prev, item]
      );
    },
    [setHospitalsFilter]
  );

  const handleHospitalsClear = () => {
    setHospitalsFilter([]);
    setsearchTermForHospitals("");
  };

  function logout(params) {
    if (lungClicked) setLungClicked(false);
    signOutFun();
    navigate("/login", { replace: true });
  }
 const handleLungClick = () => {
  const goingToLung = !lungClicked;
  
  // Clear all filters BEFORE navigation
  setFromDate(null);
  setToDate(null);
  setSelectedGenes([]);
  setImmunoFilter([]);
  setSearchTermForImmuno("");
  setTargetedFilter([]);
  setSeacrhTermForTargeted("");
  setSearchTermForGene("");
  setSearchTermForCancer("");
  setCitiesFilter([]);
  setHospitalsFilter([]);
  setIsPdlChecked(false);
  setNgsValue(null);
  setGeneDetectionStatus(null);
  setDoctorsDropdownDataFilter([]);
  setSearchTermForDoctor("");
  setsearchTermForTestType("");
  setTestTypeFilter([]);
  setMorphologyFilterVal([]);
  setSearchTermForMorphology("");

    // Clear all filters BEFORE navigation
    setFromDate(null);
    setToDate(null);
    setFromDraft(null);
    setToDraft(null);
    setSelectedGenes([]);
    setImmunoFilter([]);
    setSearchTermForImmuno("");
    setTargetedFilter([]);
    setSeacrhTermForTargeted("");
    setSearchTermForGene("");
    setSearchTermForCancer("");
    setCitiesFilter([]);
    setHospitalsFilter([]);
    setIsPdlChecked(false);
    setNgsValue(null);
    setGeneDetectionStatus(null);
    setDoctorsDropdownDataFilter([]);
    setSearchTermForDoctor("");
    setsearchTermForTestType("");
    setTestTypeFilter([]);
    setMorphologyFilterVal([]);
    setSearchTermForMorphology("");
    setClinicalSignificanceFilter([]);
    setSearchTermForClinical("");

    // Handle cancer filter based on direction
    if (goingToLung) {
      // Going to Lung: clear cancer filter, let useEffect set it
      setCancerFilterVal1([]);
      setWasManuallyCleared(false);
    }

    setSelectedQuickRange("");

    // Update lung state
    setLungClicked(goingToLung);



    // Determine the correct path based on current view
    let targetPath;
    if (is1kViewEnabled) {
      targetPath = goingToLung ? "/Lung" : "/demo1k";
      // Pass state to indicate we're coming from Pathology
      if (goingToLung) {
        navigate(targetPath, { state: { fromPathology: true } });
      } else {
        navigate(targetPath);
      }
    } else {
      targetPath = goingToLung ? "/Lung" : "/Dashboard";
      navigate(targetPath);
    }
    navigate(targetPath);
    if (fromDate !== null) setFromDate(null);
    if (toDate !== null) setToDate(null);
    if (selectedGenes.length > 0) setSelectedGenes([]);
    if (immunoFilter.length > 0) setImmunoFilter([]);
    if (searchTermForImmuno !== "") setSearchTermForImmuno("");
    if (targetedFilter.length > 0) setTargetedFilter([]);
    if (seacrhTermForTargeted !== "") setSeacrhTermForTargeted("");
    if (searchTermForGene !== "") setSearchTermForGene("");
    if (searchTermForCancer !== "") setSearchTermForCancer("");
    if (citiesFilter.length > 0) setCitiesFilter([]);
    if (hospitalsFilter.length > 0) setHospitalsFilter([]);
    if (isPdlChecked !== false) setIsPdlChecked(false);
    if (ngsValue !== null) setNgsValue(null);
    if (geneDetectionStatus !== null) setGeneDetectionStatus(null);
    if (doctorsDropdownDataFilter.length > 0) setDoctorsDropdownDataFilter([]);
    if (searchTermForDoctor !== '') setSearchTermForDoctor('');
    if (searchTermForTestType !== '') setsearchTermForTestType('');
    if (testTypeFilter.length > 0) setTestTypeFilter([]);
    if (morphologyFilterVal.length > 0) setMorphologyFilterVal([]);
    if (searchTermForMorphology !== '') setSearchTermForMorphology('');
    if (genderFilter.length > 0) setGenderFilter([]);


    if (goingToLung) {
      if (wasManuallyCleared !== false) setWasManuallyCleared(false);
    } else {
      if (cancerFilterVal1.length > 0) setCancerFilterVal1([]);
    }
  };

  const handleClick = () => {
    setLungClicked(false);
    setCancerFilterVal1([]);
    navigate("/");
  };
  const formatNgsValue = (value) => {
    switch (value) {
      case "Non-NGS":
        return "NON_NGS";
      case "Both":
        return "BOTH";
      default:
        return value;
    }
  };

  const formatGender = (value) => {
    
    if (!value) return ""; // handles null, undefined, empty

    switch (value) {
      case "UNKNOWN":
        return "Research";    
      default:
        return value;
    }
  };

  return (
    <div className="dashboard">
      <div className="top_header ">
        <div className="header_left pt-0">
          <img alt="" src={gcda_logo} />
        </div>
        <div className="header_right">
          {userDetails?.role !== Roles.LUNG_ANALYST && (
            (userDetails?.role !== Roles.DOCTOR_ANALYST) ||
            (userDetails?.role === Roles.DOCTOR_ANALYST &&
              process.env.REACT_APP_LUNGS_ALLIANCE_FEATURE === "enable" && hasLungCancerSite))
            && (
              <>
                {!is1kViewEnabled && (
                  <div >
                    <button
                      type="button"
                      className="btn btn_style"
                      onClick={handleLungClick}
                    >
                      {lungClicked ? "Dashboard" : "LuNGS Alliance"}
                    </button>
                  </div>)}               
                                 
              </>
            )}
            <button
              type="button"
              className="btn btn_style"
              onClick={handleClick}
            >
              Home
            </button> 

          <div className="dropdown">
            <button
              type="button"
              data-toggle="dropdown"
              className="btn btn_blue gradient_btn"
            >
              OV
            </button>
            <div className="dropdown-menu">
              <button className="dropdown-item" onClick={() => logout()}>
                Logout
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="dashboard_wrapper mt_top-80">
        <div className="dash_inner">
          {/* <div className='sideNav'> */}
          <div
            className={`sideNav ${isSidebarOpen ? "expanded" : "collapsed"}`}>
            <div className="nav_icon">
              <div className="fil_title">
                <span className="mr-2 open_sidenav">
                  <img
                    src={filter}
                    alt=""
                    onClick={() => {
                      setIsSidebarOpen(true);
                    }}
                  />
                </span>
                {isSidebarOpen && <span>Filter by</span>}
              </div>
              {isSidebarOpen && (
                <div className="">
                  <button
                    type="button"
                    className="btn btn-outline_cyan clear_btn"
                    onClick={handleClearAll}
                  >
                    Clear all{" "}
                  </button>
                  <span className="ml-3 close_nav">
                    <img
                      alt=""
                      src={arrowLeft}
                      onClick={() => {
                        setIsSidebarOpen(false);
                      }}
                    />
                  </span>
                </div>
              )}
            </div>
            {isSidebarOpen && (
              <nav className="accordion arrows">
                <input type="checkbox" name="accordion" id="cb1" />
                {!is1kViewEnabled && process.env.REACT_APP_DATE_FILTER === "true" && (
                  <section className="box">
                    <label className="box-title" htmlFor="cb1">
                      <span className="icon">
                        <Icon name="timeRange" />
                      </span>
                      <h6 className="mb-0">Date Range</h6>
                    </label>
                    <label className="box-close" htmlFor="cb1"></label>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <div className="box-content calender_select date_pick-arrow-btn">

                        {/* QUICK RANGE SELECT */}
                        <div className="box_inner">          
                          <div className="quick-select-tabs">
                            {['1M', '3M', '6M', '1Y'].map(option => {
                              const totalMonths = (minDate && maxDate) ? dayjs(maxDate).diff(dayjs(minDate), 'month') : Infinity;
                              let isDisabled = false;
                              if (option === '1M' && totalMonths < 1) isDisabled = true;
                              if (option === '3M' && totalMonths < 3) isDisabled = true;
                              if (option === '6M' && totalMonths < 6) isDisabled = true;
                              if (option === '1Y' && totalMonths < 12) isDisabled = true;

                              return (
                                <button
                                  key={option}
                                  type="button"
                                  className={`quick-select-tab ${activeQuickRange === option ? 'active' : ''}`}
                                  onClick={() => handleQuickDateSelect(option)}
                                  disabled={isDisabled}
                                >
                                  {option}
                                </button>
                              );
                            })}
                          </div>
                        </div>

                        {/* FROM DATE */}
                        <div className="box_inner">
                          <span className="head input_width">From:</span>
                          <DatePicker
                            value={fromDraft}
                            onChange={handleFromChange}
                            onAccept={handleFromAccept}
                            minDate={minDate ? dayjs(minDate) : undefined}
                            maxDate={maxDate ? dayjs(maxDate) : dayjs()}
                            format="DD/MM/YYYY"
                            disabled={dateRangeLoading || !hasApiData}
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                error: Boolean(fromError),
                                helperText: fromError || (dateRangeLoading ? "Loading date range..." : !hasApiData ? "Date range not available" : ""),
                              },
                            }}
                          />
                        </div>

                        {/* TO DATE */}
                        <div className="box_inner">
                          <span className="head input_width">To:</span>
                          <DatePicker
                            value={toDraft}
                            onChange={handleToChange}
                            onAccept={handleToAccept}
                            minDate={fromDate ? fromDate : (minDate ? dayjs(minDate) : undefined)}
                            maxDate={maxDate ? dayjs(maxDate) : dayjs()}
                            format="DD/MM/YYYY"
                            disabled={dateRangeLoading || !hasApiData}
                            slotProps={{
                              textField: {
                                size: "small",
                                fullWidth: true,
                                error: Boolean(toError),
                                helperText: toError || (dateRangeLoading ? "Loading date range..." : !hasApiData ? "Date range not available" : ""),
                              },
                            }}
                          />
                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                            marginTop: "10px",
                          }}
                        >
                          <button
                            className="save-button inside-dropdown small_button"
                            onClick={handlerClearr}
                            disabled={!fromDate && !toDate}
                          >
                            Clear
                          </button>
                        </div>
                      </div>
                    </LocalizationProvider>
                  </section>
                )}

                <input type="checkbox" id="cb11" />
                <section className="box">
                  <label className="box-title" htmlFor="cb11">
                    <span className="icon">
                      <Icon name="ngs" />
                    </span>
                    <h6 className="mb-0">NGS</h6>
                    {/* {ngsValue && <span className="numb">{ngsValue}</span>} */}
                  </label>

                  <label className="box-close" htmlFor="cb11"></label>
                  <div className="cancer-selector-container">
                    <div className="box-content">
                      <div
                        className="box-content-scroll_height"
                        style={{
                          maxHeight: "123px",
                          overflowY: "auto",
                          marginBottom: "1px",
                        }}
                      >
                        {ngsOptions.map((type) => (
                          <div
                            key={type}
                            className={`box_inner ${ngsValue === formatNgsValue(type) ? "active" : ""
                              }`}
                            onClick={() => handleNgsSelect(type)}>
                            <span className="head">{type}</span>
                          </div>
                        ))}
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        <button
                          className="save-button inside-dropdown small_button"
                          disabled={!ngsValue}
                          onClick={() => setNgsValue(null)}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </section>

                {process.env.REACT_APP_GENE_DETECTION_STATUS === "true" && <input type="checkbox" name="accordion" id="cb14" />}
                {process.env.REACT_APP_GENE_DETECTION_STATUS === "true" &&
                  <section className="box">
                    <label className="box-title" htmlFor="cb14">
                      <span className="icon">
                        <Icon name="ngs" />
                      </span>
                      <h6 className="mb-0">Gene Detection Status</h6>
                    </label>

                    <label className="box-close" htmlFor="cb14"></label>

                    <div className="cancer-selector-container">
                      <div className="box-content">
                        <div
                          className="box-content-scroll_height"
                          style={{
                            maxHeight: "123px",
                            overflowY: "auto",
                            marginBottom: "1px",
                          }}
                        >
                          {geneDetectionStatusOptions.map((type) => (
                            <label
                              className={`box_inner ${geneDetectionStatus === type.toLowerCase() ? "active" : ""}`} key={type}
                            >
                              <input
                                type="radio"
                                name="geneDetectionStatus"
                                value={type}
                                checked={geneDetectionStatus === type.toLowerCase()}
                                onChange={() => setGeneDetectionStatus(type.toLowerCase())}
                              />
                              <span className="head">{type}</span>
                            </label>
                          ))}

                        </div>

                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                          }}
                        >
                          <button
                            className="save-button inside-dropdown small_button"
                            disabled={!geneDetectionStatus}
                            onClick={() => setGeneDetectionStatus(null)}
                          >
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </section>}

                <input type="checkbox" name="accordion" id="cb2" />
                <section className="box">
                  <label className="box-title" htmlFor="cb2">
                    <span className="icon">
                      <Icon name="cancerSites" />
                    </span>
                    <h6 className="mb-0">Cancer sites</h6>
                    <span className="numb">{selectedCategoryCount}</span>
                  </label>
                  <label className="box-close" htmlFor="cb2"></label>

                  <div className="cancer-selector-container">
                    <div className="box-content-cancersite_section">
                      <div className="search_panel">
                        <div className="search-wrapper">
                          <input
                            type="text"
                            className="search-input"
                            placeholder="Search cancer site..."
                            value={searchTermForCancer}
                            onChange={(e) => setSearchTermForCancer(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="panelsidebar">
                        <div className="cancer-groups">
                          {filteredSites?.map((group, i) => {
                            const selectedCount = group.matchedSites
                              .map(site => site.name)
                              .filter(siteName => cancerFilterVal1.includes(siteName))
                              .length;
                            return (
                              <div key={i} className="cancer-group cancer_site-header px-0">
                                <div
                                  className="group-header"
                                  onClick={() => toggleGroup(group.name)}
                                >
                                  <div className="group-header-main">
                                    {selectedCount > 0 && <span className="numb">{selectedCount}</span>}
                                    <h6 className="mb-0">{group.name}</h6>
                                  </div>

                                  {openGroups[group.name] ? (
                                    <span className="arrow">
                                      <i className="zmdi zmdi-chevron-up"></i>
                                    </span>
                                  ) : (

                                    <span className="circle-number">
                                      <span className="total-count-text">
                                        {group.total}
                                      </span>
                                      <i className="zmdi zmdi-chevron-down"></i>
                                    </span>
                                  )}
                                </div>

                                {openGroups[group.name] && (
                                  <div className="group-content cancersite_subsection">
                                    {(() => {
                                      const allSelected = group.matchedSites.every((site) =>
                                        cancerFilterVal1.includes(site.name)
                                      );

                                      return (
                                        <>
                                          <div className="select-all-row pl-0">
                                            <label
                                              className={`select-all-label ${allSelected ? "active" : ""} ${selectedCount > 0 ? "selected-count" : ""
                                                }`}
                                            >
                                              <input
                                                type="checkbox"
                                                checked={allSelected}
                                                onChange={() => handleSelectAllGroup(group)}
                                              />
                                              Select All
                                              <span
                                                className={`subcircle-value ${allSelected ? "selected" : ""}`}>
                                                {group.total}
                                              </span>
                                            </label>
                                          </div>

                                          <ul>
                                            {group.matchedSites.map((site, j) => {
                                              const checked = cancerFilterVal1.includes(site.name);
                                              return (
                                                <li
                                                  key={j}
                                                  className="list-item"
                                                  onClick={() => toggleSite(group.name, site.name)}
                                                >
                                                  <span
                                                    className={`text-color ${checked && !allSelected ? "active" : "inactive"
                                                      }`}
                                                  >
                                                    {site.name}
                                                  </span>

                                                  <span
                                                    className={`subcircle-value ${checked ? (allSelected ? "all-selected" : "selected") : ""
                                                      }`}
                                                  >
                                                    {site.value}
                                                  </span>

                                                </li>
                                              );
                                            })}
                                          </ul>
                                        </>
                                      );
                                    })()}
                                  </div>
                                )}


                              </div>
                            );
                          })}
                        </div>
                      </div>

                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        <button
                          className="save-button inside-dropdown small_button"
                          onClick={handleClear}
                          disabled={cancerFilterVal1.length === 0}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </section>

                                <input type="checkbox" name="accordion" id="cb8" />
                {/* Morphology Types */}
                <section className="box">
                  <label className="box-title" htmlFor="cb8">
                    <span className="icon">
                      <Icon name="morphologyTypes" />
                    </span>
                    <h6 className="mb-0">Morphology Types</h6>
                    <span className="numb">{selectedVisibleMorphCount}</span>
                  </label>
                  <label className="box-close" htmlFor="cb8"></label>
                  <div className="cancer-selector-container">
                    <div className="box-content">
                      <div className="search-wrapper ">
                        <input
                          type="text"
                          className="search-input"
                          placeholder="Search Morphology Type..."
                          aria-label="Search Morphology Type"
                          value={searchTermForMorphology}
                          onChange={(e) =>
                            setSearchTermForMorphology(e.target.value)
                          }
                        />
                      </div>
                      <div className="box-content-scroll_height">
                        {filteredMorphology.map((mtype, index) => {
                          const isSelected = morphologyFilterVal.some(
                            (t) => t.name === mtype.name
                          );
                          return (
                            <div
                              key={index}
                              className={`box_inner ${isSelected ? "active" : ""
                                }`}
                              onClick={() => toggleMorphology(mtype)}
                            >
                              <span className="head">{mtype.name}</span>
                              <span
                                className={`circle-value ${isSelected ? "selected" : ""
                                  }`}
                              >
                                {mtype.value}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        <button
                          className="save-button inside-dropdown small_button"
                          onClick={handlMorphologySelectAll}
                        >
                          Select All
                        </button>
                        <button
                          className="save-button inside-dropdown small_button"
                          onClick={handleMorphologyClear}
                          disabled={morphologyFilterVal.length === 0}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </section>

               <input type="checkbox" name="accordion" id="cb18" />
                  <section className="box">
                  <label className="box-title" htmlFor="cb18">
                    <span className="icon">
                      <Icon name="geneName" />
                    </span>
                    <h6 className="mb-0">Gene</h6>
                  </label>
                  <label className="box-close" htmlFor="cb18"></label>

                  <div className="cancer-selector-container geneBoxcontent">
                    <div className="box-content" style={{ maxHeight: "fit-content" }}>
                      <div className="search-wrapper ">
                        <span className="search-image">
                          <img src={searchIcon} />
                        </span>
                        <input
                          type="text"
                          className="search-input"
                          placeholder="Search Gene"
                          value={searchTermForGene}
                          onChange={(e) => setSearchTermForGene(e.target.value)}
                        />
                      </div>
                      <button
                        className="select-all"
                        onClick={handleGeneSelectAll}
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          width: "100%"
                        }}
                      >
                        <span className={`select-all ${selectedGenes?.length === filteredSites2?.length
                          && filteredSites2?.length !== 0 ? "active" : ""}`}>Select All</span>
                        <span className={`circle-number ${selectedGenes?.length === filteredSites2?.length && filteredSites2?.length !== 0 ? "selected" : ""}`}>
                          {filteredSites2?.length || 0}
                        </span>
                      </button>
                      <div className="box-content-scroll_height boxContent-left-space">
                        {filteredSites2?.map((biomarker, index) => {
                          const isSelected = selectedGenes.some(
                            (s) => s.biomarkerName === biomarker.biomarkerName
                          );
                          const allSelected = selectedGenes?.length === filteredSites2?.length;
                          return (
                            <div
                              key={index}
                              className={`box_inner ${allSelected && isSelected ? "" : isSelected ? "active" : ""}`}
                              onClick={() => toggleGene(biomarker)}
                            >
                              <span className="head" title={biomarker.biomarkerName}>
                                {formatBiomarkerName(biomarker.biomarkerName)}
                              </span>
                              <span className={`circle-value ${allSelected ? "subcircle-value all-selected" : isSelected ? "selected" : ""}`}>
                                {biomarker.totalCancerSiteCount}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                      </div>
                    </div>
                  </div>
                  </section>
                  {process.env.REACT_APP_CLINICAL_SIGNIFICANCE_FILTER === "true" && (
                    <>
                      <input type="checkbox" name="accordion" id="cb19" />
                      <section className="box">
                      <label className="box-title" htmlFor="cb19">
                      <span className="icon">
                        <Icon name="gene" />
                      </span>
                      <h6 className="mb-0">Clinical Sig. of Variant</h6>
                    </label>                      
                    <label className="box-close" htmlFor="cb19"></label>

                  <div className="cancer-selector-container geneBoxcontent">
                    <div className="box-content">
                      <div>
                        <div className="search-wrapper ">
                          <span className="search-image">
                            <img src={searchIcon} alt="" />
                          </span>
                          <input
                            type="text"
                            className="search-input"
                            placeholder="Search Clinical Significance ..."
                            value={searchTermForClinical}
                            onChange={(e) => setSearchTermForClinical(e.target.value)}
                          />
                        </div>
                        <button
                          className="select-all"
                          onClick={handleClinicalSelectAll}
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            width: "100%"
                          }}
                        >
                          <span className={`select-all ${clinicalSignificanceFilter?.length === clinicallfiltered?.length
                            && clinicallfiltered?.length !== 0 ? "active" : ""}`}>Select All</span>
                          <span className={`circle-number ${clinicalSignificanceFilter?.length === clinicallfiltered?.length && clinicallfiltered?.length !== 0 ? "selected" : ""}`}>
                            {clinicalSignificanceTotal || 0}
                          </span>
                        </button>
                      </div>

                      <div className="box-content-scroll_height boxContent-left-space">
                        {clinicallfiltered?.map((item, index) => {
                          const isSelected = clinicalSignificanceFilter.some((s) => s.name === item.name);
                          const allSelected = clinicalSignificanceFilter?.length === clinicallfiltered?.length;
                          return (
                            <div
                              key={index}
                              className={`box_inner ${allSelected ? "" : isSelected ? "active" : ""}`}
                              onClick={() => toggleClinicalSignificance(item)}
                            >
                              <span className="head">{item.name}</span>
                              <span className={`circle-value ${allSelected ? "subcircle-value all-selected" : isSelected ? "selected" : ""}`}>
                                {item.value}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                    </div>
                </div>
              </section>
                    </>
                  )}

                <input type="checkbox" name="accordion" id="cb7" />
                {/* PD-L1 Checkbox Section */}
                <section className="box pdl1_checkbox">
                  <label className="box-title" htmlFor="cb7">
                    <span className="icon">
                      <Icon
                        name="pdl1"
                        color={isPdlChecked ? "#00629d" : "#41474d"}
                      />
                    </span>
                    <h6
                      className="mb-0"
                      style={{
                        color: isPdlChecked ? "#00629d" : "#41474d",
                      }}
                    >
                      PD-L1
                    </h6>
                    <input
                      id="pdl1-checkbox"
                      type="checkbox"
                      className="pdl1_input"
                      checked={isPdlChecked}
                      onChange={(e) => setIsPdlChecked(e.target.checked)}
                    />
                  </label>
                </section>

                <input type="checkbox" name="accordion" id="cb4" />
                <section className="box">
                  <label className="box-title" htmlFor="cb4">
                    <span className="icon">
                      <Icon name="immunotherapy" />
                    </span>
                    <h6 className="mb-0">Immunotherapy</h6>
                    <span className="numb">{immunoFilter?.length}</span>
                  </label>
                  <label className="box-close" htmlFor="cb4"></label>
                  <div className="cancer-selector-container">
                    <div className="box-content">
                      <div className="search-wrapper ">
                        <input
                          type="text"
                          className="search-input"
                          placeholder="Search Immuno ..."
                          value={searchTermForImmuno}
                          onChange={(e) =>
                            setSearchTermForImmuno(e.target.value)
                          }
                        />
                      </div>
                      <div className="box-content-scroll_height">
                        {filteredSites1.map((site, index) => {
                          const isSelected = immunoFilter.some(
                            (s) => s.name === site.name
                          );
                          return (
                            <div
                              key={index}
                              className={`box_inner ${isSelected ? "active" : ""
                                }`}
                              onClick={() => toggleImmuno(site)}
                            >
                              <span className="head">{site.name}</span>
                              <span
                                className={`circle-value ${isSelected ? "selected" : ""
                                  }`}
                              >
                                {site.value}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        <button
                          className="save-button inside-dropdown small_button"
                          onClick={handleImmunoSelectAll}
                        >
                          Select All
                        </button>
                        <button
                          className="save-button inside-dropdown small_button"
                          onClick={handleImmunoClear}
                          disabled={immunoFilter.length === 0}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </section>

                <input type="checkbox" name="accordion" id="cb9" />
                <section className="box">
                  <label className="box-title" htmlFor="cb9">
                    <span className="icon">
                      <Icon name="targetedTherapy" />
                    </span>
                    <h6 className="mb-0">Targeted Therapy</h6>
                    <span className="numb">{targetedFilter?.length}</span>
                  </label>
                  <label className="box-close" htmlFor="cb9"></label>
                  <div className="cancer-selector-container">
                    <div className="box-content">
                      <div className="search-wrapper ">
                        <input
                          type="text"
                          className="search-input"
                          placeholder="Search Targeted ..."
                          value={seacrhTermForTargeted}
                          onChange={(e) =>
                            setSeacrhTermForTargeted(e.target.value)
                          }
                        />
                      </div>
                      <div className="box-content-scroll_height">
                        {targetedTherapyfiltered.map((site, index) => {
                          const isSelected = targetedFilter.some(
                            (s) => s.name === site.name
                          );
                          return (
                            <div
                              key={index}
                              className={`box_inner ${isSelected ? "active" : ""
                                }`}
                              onClick={() => toggleTargeted(site)}
                            >
                              <span className="head">{site.name}</span>
                              <span
                                className={`circle-value ${isSelected ? "selected" : ""
                                  }`}
                              >
                                {site.value}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "0.5rem",
                        }}
                      >
                        <button
                          className="save-button inside-dropdown small_button"
                          onClick={handleTargetedSelectAll}
                        >
                          Select All
                        </button>
                        <button
                          className="save-button inside-dropdown small_button"
                          onClick={handleTargetedClear}
                          disabled={targetedFilter.length === 0}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </section>

                <input type="checkbox" name="accordion" id="cb6" />
                {userDetails?.role !== Roles.PATHOLOGY_ANALYST &&
                  <section className="box hospital_icon">
                    <label className="box-title" htmlFor="cb6">
                      <span className="icon">
                        <Icon name="hospitals" />
                      </span>
                      <h6 className="mb-0">Hospitals </h6>
                      <span className="numb">{hospitalsFilter?.length}</span>
                    </label>
                    <label className="box-close" htmlFor="cb6"></label>
                    <div className="cancer-selector-container">
                      <div className="box-content">
                        <div className="search-wrapper ">
                          <input
                            type="text"
                            className="search-input"
                            placeholder="Search Hopsital ..."
                            value={searchTermForHospitals}
                            onChange={(e) =>
                              setsearchTermForHospitals(e.target.value)
                            }
                          />
                        </div>
                        <div className="box-content-scroll_height">
                          {filteredSites4?.map((hospital, index) => {
                            const isSelected = hospitalsFilter?.some(
                              (c) => c.name === hospital.name
                            );
                            return (
                              <div
                                key={index}
                                className={`box_inner ${isSelected ? "active" : ""
                                  }`}
                                onClick={() => toggleHospitals(hospital)}
                              >
                                <span className="head">{hospital.name}</span>
                                <span
                                  className={`circle-value ${isSelected ? "selected" : ""
                                    }`}
                                >
                                  {hospital.value}
                                </span>
                              </div>
                            );
                          })}
                        </div>
                        <div
                          style={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: "8px",
                          }}
                        >
                          <button
                            className="save-button inside-dropdown small_button"
                            onClick={handleHospitalsSelectAll}
                          >
                            Select All
                          </button>
                          <button
                            className="save-button inside-dropdown small_button"
                            onClick={handleHospitalsClear}
                            disabled={hospitalsFilter.length === 0}
                          >
                            Clear
                          </button>
                        </div>
                      </div>
                    </div>
                  </section>}

                <input type="checkbox" name="accordion" id="cb5" />
                <section className="box ">
                  <label className="box-title" htmlFor="cb5">
                    <span className="icon">
                      <Icon name="hospitalCities" />
                    </span>
                    <h6 className="mb-0">Hospital Cities</h6>
                    <span className="numb">{citiesFilter?.length}</span>
                  </label>
                  <label className="box-close" htmlFor="cb5"></label>
                  <div className="cancer-selector-container">
                    <div className="box-content">
                      <div className="search-wrapper ">
                        <input
                          type="text"
                          className="search-input"
                          placeholder="Search City ..."
                          value={searchTermForCities}
                          onChange={(e) =>
                            setSeacrhTermForCities(e.target.value)
                          }
                        />
                      </div>
                      <div className="box-content-scroll_height">
                        {filteredSites3?.map((city, index) => {
                          const isSelected = citiesFilter?.some(
                            (c) => c.name === city.name
                          );
                          return (
                            <div
                              key={index}
                              className={`box_inner ${isSelected ? "active" : ""
                                }`}
                              onClick={() => toggleCities(city)}
                            >
                              <span className="head">{city.name}</span>
                              <span
                                className={`circle-value ${isSelected ? "selected" : ""
                                  }`}
                              >
                                {city.value}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexWrap: "wrap",
                          gap: "8px",
                        }}
                      >
                        <button
                          className="save-button inside-dropdown small_button"
                          onClick={handleCitiesSelectAll}
                        >
                          Select All
                        </button>
                        <button
                          className="save-button inside-dropdown small_button"
                          onClick={handleCitiesClear}
                          disabled={citiesFilter.length === 0}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </section>

                {process.env.REACT_APP_LIST_OF_DOCTORS === "true" && userDetails?.role === Roles.ANALYST && (
                  <>
                    <input type="checkbox" name="accordion" id="cb10" />
                    <section className="box">
                      <label className="box-title" htmlFor="cb10">
                        <span className='icon'>
                          <Icon name="doctorslist" />
                        </span>
                        <h6 className='mb-0'>List of Doctors</h6>
                        <span className='numb'>{doctorsDropdownDataFilter?.length}</span>
                      </label>
                      <label className="box-close" htmlFor="cb10"></label>
                      <div className="cancer-selector-container">
                        <div className="box-content">
                          <div className="search-wrapper ">
                            <input
                              type="text"
                              className="search-input"
                              placeholder="Search Doctor..."
                              aria-label="Search Doctor"
                              value={searchTermForDoctor}
                              onChange={handleDoctorSearchChange}
                            />
                          </div>
                          <div className="box-content-scroll_height">
                            {filteredDoctors.map((doctor, index) => {
                              const isSelected = doctorsDropdownDataFilter.some(d => d.name === doctor.name);
                              return (
                                <div
                                  key={index}
                                  className={`box_inner ${isSelected ? 'active' : ''}`}
                                  onClick={() => toggleDoctorDropdown(doctor)}
                                >
                                  <span className="head">{doctor.name}</span>
                                  <span className={`circle-value ${isSelected ? 'selected' : ''}`}>
                                    {doctor.value}
                                  </span>
                                </div>
                              );
                            })}
                          </div>
                          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
                            <button
                              className="save-button inside-dropdown small_button"
                              onClick={handleDoctorSelectAll}
                            >
                              Select All
                            </button>
                            <button
                              className="save-button inside-dropdown small_button"
                              onClick={handleDOctorClear}
                              disabled={doctorsDropdownDataFilter.length === 0}
                            >
                              Clear
                            </button>
                          </div>
                        </div>
                      </div>
                    </section>
                  </>)}

                {process.env.REACT_APP_TEST_DETAILS === "true" && <><input type="checkbox" name="accordion" id="cb12" /><section className="box">
                  <label className="box-title" htmlFor="cb12">
                    <span className='icon'>
                      <Icon name="testDetails" />
                    </span>
                    <h6 className='mb-0'>Test Details</h6>
                    <span className='numb'>{testTypeFilter?.length}</span>
                  </label>
                  <label className="box-close" htmlFor="cb12"></label>
                  <div className="cancer-selector-container">
                    <div className="box-content">
                      <div className="search-wrapper ">
                        <input
                          type="text"
                          className="search-input"
                          placeholder="Search Test Details..."
                          value={searchTermForTestType}
                          onChange={handleTestypeSearchChange}
                        />
                      </div>
                      <div className="box-content-scroll_height">
                        {filteredTestTypes?.map((site, index) => {
                          const isSelected = testTypeFilter?.some((s) => s.name === site.name);
                          return (
                            <div
                              key={index}
                              className={`box_inner ${isSelected ? "active" : ""}`}
                              onClick={() => toggleTestType(site)}
                            >
                              <span className="head">{site.name}</span>
                              <span className={`circle-value ${isSelected ? "selected" : ""}`}>
                                {site.value}
                              </span>
                            </div>
                          );
                        })}
                      </div>
                      <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', paddingBottom: '1rem' }}>
                        <button
                          className="save-button inside-dropdown small_button"
                          onClick={handleTestTypeSelectAll}
                        >
                          Select All
                        </button>
                        <button
                          className="save-button inside-dropdown small_button"
                          disabled={testTypeFilter?.length === 0}
                          onClick={handleTestTypeClear}
                        >
                          Clear
                        </button>
                      </div>
                    </div>
                  </div>
                </section>
                </>
                }

              <input type="checkbox" name="accordion" id="cbGender" />
                  <section className="box">
                    <label className="box-title" htmlFor="cbGender">
                      <span className="icon">
                        <Icon name="gender" /> 
                      </span>
                        <h6 className="mb-0">Genders</h6>
                      <span className="numb">{genderFilter?.length}</span>
                    </label>
                    <label className="box-close" htmlFor="cbGender"></label>
                <div className="cancer-selector-container">
                  <div className="box-content">
                    <div className="box-content-scroll_height">
                        {genderDropdown?.map((site, index) => {const isSelected = genderFilter?.some(
                          (s) => s.name === site.name
                        );
                      return (
                        <div
                          key={index}
                          className={`box_inner ${isSelected ? "active" : ""}`}
                          onClick={() => toggleGender(site)}
                        >
                          <span className="head">{formatGender(site.name)}</span>
                          <span
                            className={`circle-value ${isSelected ? "selected" : ""}`}
                          >
                            {site.value}
                          </span>
                        </div>
                        );
                      })}
                    </div> 
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px', paddingBottom: '1rem' }}>
                     <button
                      className="save-button inside-dropdown small_button"
                      onClick={handleGenderSelectAll}
                    >
                        Select All
                      </button>
                      <button
                       className="save-button inside-dropdown small_button"
                        onClick={handleGenderClear}
                        disabled={genderFilter?.length === 0}
                      >
                       Clear
                      </button>
                    </div>
              </div>
          </div>
          </section>
              </nav>
            )}
          </div>
          {/* <div className='content_panel p-20'> */}
          <div
            className={`content_panel p-20 ${isSidebarOpen ? "expanded-open" : "sidebar-collapsed"
              }`}
          >
            {IsLoading && (
              <div className="downloadLoader ">
                {/*<Loader type="spinner-circle" bgColor='black' title={"loading..."} color={'#FFFFFF'} size={100} />*/}
              </div>
            )}
            <div className="title">
              <h3>{lungClicked ? "LuNGS Alliance" : "Dashboard"}</h3>
            </div>
            <CancerSites
              CancerSitesLoader={CancerSitesLoader}
              totalValue={totalValue}
              primarySite={primarySite}
              Fullscreen={Fullscreen}
              cancerSiteTop10Data={cancerSiteTop10Data}
              Highcharts={Highcharts}
              topcansites={topcansites}
              top10totalCount={top10totalCount}
              cancerSiteRestOfData={cancerSiteRestOfData}
              resofcansites={resofcansites}
              totalCount={totalCount}
            />

            {/* 2nd row */}
            <MorphologySomaticGermlineLazyLoadWrapper
              SomaticGermlineAPICall={SomaticGermlineAPICall}
              MorphologySomaticGermlineLoader={MorphologySomaticGermlineLoader}
              somaticTotal={somaticTotal}
              Fullscreen={Fullscreen}
              somaticGermline={somaticGermline}
              Highcharts={Highcharts}
              morphologyData={morphologyData}
              morphTotalCount={morphTotalCount}
              morphPie={morphPie}
              morphologyDataAPICall={morphologyDataAPICall}

            />

            {/* 3rd row */}
            <BiomarkersLazyLoadWrapper
              BiomarkersAPICall={BiomarkersAPICall}
              BiomarkersLoader={BiomarkersLoader}
              Fullscreen={Fullscreen}
              geneCancer={geneCancer}
              Highcharts={Highcharts}
              options={options}
            />
            <VarinatAndProteinDistrubutionLazyLoadWrapper
              Fullscreen={Fullscreen}
              Highcharts={Highcharts}
              lungClicked={lungClicked}
              isSidebarOpen={isSidebarOpen}
              proteinChangeDetails={proteinChangeDetails}
              variantTypeTotal={variantTypeTotal}
              variantTypeResponse={variantTypeResponse}
              varianttype={varianttype}

            />

            {/* 4th row - TMB/MSI/PDL (hidden for 1K Dashboard) */}
            {!is1kViewEnabled && (
              <TmbMsiPdlLazyLoadWrapper
                TmbMsiPdlAPICall={TmbMsiPdlAPICall}
                TmbMsiPdlLoader={TmbMsiPdlLoader}
                tmbTotal={tmbTotal}
                Fullscreen={Fullscreen}
                tmbData={tmbData}
                Highcharts={Highcharts}
                tmboptions={tmboptions}
                msiData={msiData}
                msiTotal={msiTotal}
                msioptions={msioptions}
                pdloptions={pdloptions}
                pdlTotal={pdlTotal}
                pdlData={pdlData}
              />
            )}

            {/* 5th row */}

            <TreatmentDetailsLazyLoadWrapper
              TreatmentDetailsLoader={TreatmentDetailsLoader}
              TreatmentDetailsAPICall={TreatmentDetailsAPICall}
              treatmentsTotal={treatmentsTotal}
              Fullscreen={Fullscreen}
              treatmentDetails={treatmentDetails}
              Highcharts={Highcharts}
              treatmentoptions={treatmentoptions}
              drugTotal={drugTotal}
              drugTherapy={drugTherapy}
              druggoptions={druggoptions}
              biologicalTotal={biologicalTotal}
              biologicalTherapy={biologicalTherapy}
              biooptions={biooptions}
            />

            {/* 6th row */}
            <DrugTherapyLazyLoadWrapper
              DrugTherapyLoader={DrugTherapyLoader}
              DrugTherapyAPICall={DrugTherapyAPICall}
              drugsCountTotal={drugsCountTotal}
              Fullscreen={Fullscreen}
              Highcharts={Highcharts}
              immunooptions={immunooptions}
              drugsCount={drugsCount}
              recistCriteriaTotal={recistCriteriaTotal}
              treatmentResponse={treatmentResponse}
              recistCriteria={recistCriteria}
              targtedDrugoptions={targtedDrugoptions}
              targetedTherapyTotal={targetedTherapyTotal}
              targetedTherapy={targetedTherapy}
            />

            {/* 7th row */}
            <GenderAgeDistrubtutionLazyLoadWrapper
              GenderAgeDistrubtutionLoader={GenderAgeDistrubtutionLoader}
              GenderAgeDistrubtutionAPICall={GenderAgeDistrubtutionAPICall}
              Fullscreen={Fullscreen}
              genderage={genderage}
              Highcharts={Highcharts}
              genderAgeGroup={genderAgeGroup}
              cancerstagegraph={cancerstagegraph}
              cancerStage={cancerStage}
              cancerStageTotal={cancerStageTotal}
            />

            <HospitalTestTypeLazyLoadWrapper
              HospitalAPICall={HospitalAPICall}
              HospitalTestTypeLoader={HospitalTestTypeLoader}
              Fullscreen={Fullscreen}
              Highcharts={Highcharts}
              hospitalCityTotal={hospitalCityTotal}
              hospitalCityData={hospitalCityData}
              hospitalNameData={hospitalNameData}
              hospitalsFilter={hospitalsFilter}
              citiesFilter={citiesFilter}
              lungClicked={lungClicked}
              isSidebarOpen={isSidebarOpen}
              testTypeTotalCount={testTypeTotalCount}
              testTypeGraphLoader={testTypeGraphLoader}
              testTypeGraphData={testTypeGraphData}
              testTypePie={testTypePie}
            />

          </div>
        </div>
      </div>
      {/* footer */}
      <Footer />
    </div>
  );
}

export default Dashboard;
